export default __webpack_public_path__ + "static/mx-479622e6f02e13aaf2350ca039d2f658.svg";